import { BOOKING_MODE_OPTIONS } from './MenteeSessionsConfirmPanel';

export const formatModeLabel = (mode: string | null | undefined): string => {
    if (!mode) return '—';
    const found = BOOKING_MODE_OPTIONS.find((row) => row.value === mode);
    return found?.label || mode;
};

/** Derive Mon–Fri day_of_week (1=Mon … 7=Sun) from YYYY-MM-DD. */
export const dayOfWeekFromDate = (dateStr: string): number | null => {
    const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(dateStr);
    if (!match) return null;
    const year = Number(match[1]);
    const month = Number(match[2]);
    const day = Number(match[3]);
    const utc = new Date(Date.UTC(year, month - 1, day));
    const jsDow = utc.getUTCDay();
    return jsDow === 0 ? 7 : jsDow;
};
